// ThemeBootstrap — invokes useTheme() once, above the router outlet,
// so CSS variables are injected before any page renders.

import { useTheme } from '../hooks/useTheme';

export function ThemeBootstrap() {
  useTheme();
  return null;
}
